import { useState, useEffect } from 'react';
import { Header } from './Header';

const Impressum = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const containerStyle = {
    minHeight: '100vh',
    backgroundColor: '#FDFCFF',
    fontFamily: 'PPNeueMontreal, sans-serif',
    padding: isMobile ? '92.5px 24px 60px' : '92.5px 80px 80px',
  };

  const contentStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    color: '#111111',
    lineHeight: 1.4,
  };

  const titleStyle = {
    fontSize: isMobile ? '2.5rem' : '5rem',
    fontWeight: '500',
    marginBottom: isMobile ? '2rem' : '3rem',
    color: '#111111',
    textAlign: 'left',
    lineHeight: 1.1,
  };

  const sectionStyle = {
    marginBottom: isMobile ? '3rem' : '4rem',
  };

  const sectionTitleStyle = {
    fontSize: isMobile ? '1.2rem' : '2rem',
    fontWeight: '500',
    marginBottom: '1.5rem',
    color: '#111111',
    lineHeight: 1.2,
  };

  const textStyle = {
    fontSize: isMobile ? '1rem' : '2rem',
    marginBottom: '1.5rem',
    color: '#111111',
    fontWeight: '300',
    lineHeight: 1.4,
  };

  const linkStyle = {
    color: '#0010CA',
    textDecoration: 'none',
    fontWeight: '400',
    transition: 'opacity 0.2s ease',
  };

  const addressStyle = {
    backgroundColor: '#EEEEEE',
    padding: isMobile ? '2rem' : '3rem',
    borderRadius: '8px',
    marginBottom: '1rem',
  };

  return (
    <div style={containerStyle}>
      <Header />
      <div style={contentStyle}>
        <h1 style={titleStyle}>Impressum</h1>

        <div style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Angaben gemäss Art. 3 Abs. 3 UWG</h2>
          
          <div style={addressStyle}>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? '24px' : '32px' }}>
              <div>
                <p style={{ ...textStyle, fontWeight: '500', marginBottom: '12px', color: '#0010CA' }}>Lydia Schär</p>
                <p style={{ ...textStyle, marginBottom: '4px', marginTop: '4px' }}>Geiselweidstrasse 50</p>
                <p style={{ ...textStyle, marginBottom: '4px', marginTop: '4px' }}>8400 Winterthur</p>
                <p style={{ ...textStyle, marginBottom: '4px', marginTop: '4px' }}>Schweiz</p>
              </div>
              
              <div>
                <p style={{ ...textStyle, fontWeight: '500', marginBottom: '12px', color: '#0010CA' }}>Marvin Münger</p>
                <p style={{ ...textStyle, marginBottom: '4px', marginTop: '4px' }}>Römerstrasse 52</p>
                <p style={{ ...textStyle, marginBottom: '4px', marginTop: '4px' }}>8400 Winterthur</p>
                <p style={{ ...textStyle, marginBottom: '4px', marginTop: '4px' }}>Schweiz</p>
              </div>
            </div>
          </div>
        </div>

        <div style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Kontakt</h2>
          <p style={textStyle}>
            E-Mail: <a href="mailto:info@bubbling.ch" style={linkStyle}>info@bubbling.ch</a>
          </p>
          <p style={textStyle}>
            Website: <a href="https://bubbling.ch" style={linkStyle}>www.bubbling.ch</a>
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Haftungsausschluss</h2>
          <p style={textStyle}>
            Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, 
            Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Urheberrechte</h2>
          <p style={textStyle}>
            Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen 
            Dateien auf der Website gehören ausschliesslich Bubbling oder den speziell 
            genannten Rechtsinhabern.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={sectionTitleStyle}>Datenschutz</h2>
          <p style={textStyle}>
            Gestützt auf Artikel 13 der schweizerischen Bundesverfassung und die 
            datenschutzrechtlichen Bestimmungen des Bundes (Datenschutzgesetz, DSG) 
            hat jede Person Anspruch auf Schutz ihrer Privatsphäre sowie auf Schutz 
            vor Missbrauch ihrer persönlichen Daten.
          </p>
        </div>

        <div style={{
          borderTop: '1px solid #EEEEEE',
          marginTop: '4rem',
          paddingTop: '2rem',
          textAlign: 'center',
        }}>
          <p style={{ ...textStyle, margin: 0, fontSize: isMobile ? '0.8rem' : '1rem', color: '#999999' }}>
            © 2025 Bubbling. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
